import '@aejkatappaja/phantom-ui';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { ThemeProvider } from './contexts/ThemeContext';
import CookieConsentBanner from './components/common/CookieConsentBanner';
import { initAnalyticsConsentGate } from './lib/analytics';

// Analytics (PostHog) is consent-gated and started OUTSIDE the React tree —
// accepting or changing cookie settings must never remount the app (it wiped
// in-progress wizard state when it did). See lib/analytics.ts.
initAnalyticsConsentGate();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
      <CookieConsentBanner />
    </ThemeProvider>
  </React.StrictMode>
);
